var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.queue)?_c('span',[_vm._v(_vm._s(_vm.$t('generating'))+" "+_vm._s(_vm.queue.progress)+"%")]):_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.download}},[_c('v-icon',[_vm._v("cloud_download")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }